import React from 'react';
import { ClipboardList, FileText, Rocket } from 'lucide-react';
import { processSteps } from '../data/mock';

const HowWeHelp = () => {
  const getIcon = (step) => {
    switch (step) {
      case 1: return <ClipboardList className="w-7 h-7" style={{ color: '#1F3B60' }} />;
      case 2: return <FileText className="w-7 h-7" style={{ color: '#1F3B60' }} />;
      case 3: return <Rocket className="w-7 h-7" style={{ color: '#1F3B60' }} />;
      default: return null;
    }
  };

  return (
    <section
      id="how-we-help"
      className="section-padding relative overflow-hidden grid-pattern grid-pattern-light"
      style={{ backgroundColor: '#F4F1E9' }}
    >
      {/* Subtle decorative background */}
      <div
        className="absolute top-0 right-0 w-96 h-96 rounded-full blur-3xl opacity-30"
        style={{ background: 'rgba(214, 169, 79, 0.15)' }}
      />
      <div
        className="absolute bottom-0 left-0 w-80 h-80 rounded-full blur-3xl opacity-30"
        style={{ background: 'rgba(31, 59, 96, 0.08)' }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <span className="inline-block font-semibold text-xs tracking-[0.2em] uppercase mb-4 px-4 py-1.5 rounded-full" style={{ color: '#D6A94F', backgroundColor: 'rgba(214, 169, 79, 0.08)', border: '1px solid rgba(214, 169, 79, 0.15)' }}>
            Our Process
          </span>
          <h2 className="font-display font-bold text-4xl sm:text-5xl mb-6" style={{ color: '#1F3B60' }}>
            How We Help
          </h2>
          <div className="divider-gold mx-auto mb-6" />
          <p className="max-w-2xl mx-auto text-lg" style={{ color: '#3A5A85' }}>
            A straightforward approach designed around your timeline and goals.
          </p>
        </div>

        {/* Process steps */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {processSteps.map((item, index) => (
            <div
              key={item.step}
              className="relative group"
            >
              {/* Connector line (not on last item) */}
              {index < processSteps.length - 1 && (
                <div className="hidden md:block absolute top-8 left-1/2 w-full h-0.5" style={{ background: 'linear-gradient(90deg, #1F3B60, rgba(31, 59, 96, 0.3))' }} />
              )}

              <div className="relative text-center">
                {/* Step circle */}
                <div className="step-circle mx-auto mb-6 relative z-10 group-hover:scale-110 transition-transform duration-300">
                  {getIcon(item.step)}
                </div>

                {/* Step number badge */}
                <span className="inline-block font-semibold text-sm tracking-wider mb-3" style={{ color: '#3A5A85' }}>
                  Step {item.step}
                </span>

                {/* Content */}
                <h3 className="font-display font-bold text-xl mb-4" style={{ color: '#1F3B60' }}>
                  {item.title}
                </h3>
                <p className="leading-relaxed" style={{ color: '#3A5A85' }}>
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowWeHelp;
